// src/docs/DocsVerifyProject.js
import React from "react";
import { Container, Typography, Box } from "@mui/material";

const DocsVerifyProject = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      {/* Title */}
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 2 }}>
        Verify Your Project (KYC & Document Upload)
      </Typography>
      
      {/* Introduction */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 2 }}>
        Verifying your project on CrowdLaunch is a crucial step in establishing credibility and building investor trust. 
        This process ensures that only legitimate and thoroughly vetted projects are showcased on our platform.
      </Typography>

      {/* Required Documents */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Required Documents
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        Depending on your project type, the documents required may vary:
        <br />
        • <strong>Individual Projects:</strong> Government-issued ID, proof of address, and a liveness check (selfie video with your ID).
        <br />
        • <strong>Business Projects:</strong> Company registration proof, business address verification, director identification, and financial statements.
        <br />
        • <strong>Blockchain Projects:</strong> Whitepaper, team credentials, and optional partnership or funding proofs.
      </Typography>

      {/* Document Upload Process */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Document Upload Process
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        The document upload process is straightforward:
        <br />
        1. Navigate to the verification section on your dashboard.
        <br />
        2. Fill in your personal or company details.
        <br />
        3. Upload the required documents in the supported formats (PDF, JPEG, PNG).
        <br />
        4. Submit your verification request and await approval from our team.
      </Typography>

      {/* Security & Privacy */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Security & Privacy
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        Your documents are securely stored and are only used for verification purposes. CrowdLaunch adheres to strict data protection 
        standards, ensuring that your personal and project information remains confidential.
      </Typography>

      {/* Conclusion */}
      <Typography variant="body1" sx={{ color: "#FFFFFF" }}>
        By completing the verification process, you enhance your project's credibility and gain access to premium platform features. 
        Make sure all uploaded documents are accurate and up-to-date to avoid delays in the verification process.
      </Typography>


    </Container>
  );
};

export default DocsVerifyProject;
